import './NoteLegali.css';

function NoteLegali() {
    return (
        <div className='note-legali-container'>
            <h1 className='note-legali-title'>Note Legali</h1>

            <h2>Titolare del sito</h2>
            <p>
                Associazione Settemotivi ODV – Via De Paoli n. 19 – 33170 Pordenone (PN) – C.F. 91100000933<br />
                Iscritta RUNTS repertorio n. 56893 del 17/10/2022 (già n. 1367 del Registro delle O.d.V.
                Regione Friuli Venezia Giulia)<br />
                Email: <a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a> – PEC:{' '}
                <a href="mailto:settemotivi@pec.csvfvg.it">settemotivi@pec.csvfvg.it</a>
            </p>

            <h2>Proprietà intellettuale</h2>
            <p>
                Tutti i contenuti pubblicati su questo sito (testi, immagini, loghi, grafica) sono di
                proprietà dell'Associazione Settemotivi ODV o vengono utilizzati con il consenso dei
                rispettivi autori/titolari dei diritti. È vietata la riproduzione, totale o parziale, dei
                contenuti senza la preventiva autorizzazione dell'Associazione, salvo diversa indicazione o
                uso consentito dalla legge (es. citazione a fini di cronaca, studio o critica).
            </p>

            <h2>Limitazione di responsabilità</h2>
            <p>
                L'Associazione si impegna a mantenere aggiornate e corrette le informazioni pubblicate sul
                sito, senza tuttavia garantirne la completezza o l'assenza di errori. L'Associazione non è
                responsabile per eventuali danni derivanti dall'uso o dall'impossibilità di utilizzo del
                sito, né per il contenuto dei siti esterni raggiungibili tramite i link presenti (es.
                Facebook, YouTube, siti di enti partner), sui quali non esercita alcun controllo.
            </p>

            <h2>Legge applicabile e foro competente</h2>
            <p>
                Il presente sito è regolato dalla legge italiana. Per qualsiasi controversia relativa
                all'uso del sito sarà competente il foro di Pordenone, salvo diversa disposizione
                inderogabile di legge.
            </p>
        </div>
    );
}

export default NoteLegali;
